import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

// `validateSearch` must stay in the eager route file so the router can
// parse URL params before deciding which chunk to load. The component
// (which pulls in the large JobsList screen) is split into `index.lazy.tsx`.
export const Route = createFileRoute("/app/jobs/")({
  validateSearch: z.object({
    status: z.string().optional(),
    lead_event_id: z.string().optional(),
  }),
});
